import React, { useContext } from "react";
import commonContext from "../../../context/common";

function SanctionLoanReschedulement() {
    const { lead } = useContext(commonContext);
    return (
        <>
            <div className="relative w-full">
                <p className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                    <span className="WebRupee">Rs.</span>
                    1000 will be charged. If changes are required on RC,
                    refundable security deposits - non interest bearing of ₹5000
                    would be required. It will be the borrower’s responsibility
                    to provide the transferred Registration Certificate copy to
                    Bank.
                </p>
                <div className="relative w-full">
                    <ul className="flex flex-wrap justify-between flex-row lg:flex-row">
                        <li className="mb-2 lg:mb-0 w-full lg:w-4/12">
                            <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                Stamp Duty and other statutory charges
                            </label>
                            <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                As per Applicable Law
                            </p>
                        </li>
                        <li className="mb-2 lg:mb-0 w-full lg:w-4/12">
                            <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                Overdue Interest
                            </label>
                            <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                2% per month on overdue EMI
                            </p>
                        </li>
                        <li className="mb-0 lg:mb-0 w-full lg:w-4/12">
                            <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                Taxes
                            </label>
                            <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                At actuals, applicable presently or in future
                            </p>
                        </li>
                    </ul>
                    <div className="bg-light-yellow text-grey-darkest openSans-Reg py-2 px-4 my-3 md:my-5 text-sm rounded inline-flex items-center">
                        {/* <!-- <svg className="w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"/></svg> --> */}
                        <svg
                            className="w-6 h-6 mr-2"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                            ></path>
                        </svg>
                        <span>
                            All other charges, commissions and fees shall be
                            applicable at the rate mentioned in the Application
                            form/ Sanction Letter or as stipulated by the Bank
                            from time to time and are exclusive of Taxes and
                            statutory levies as applicable.
                        </span>
                    </div>
                    <ul className="flex flex-wrap justify-between flex-row lg:flex-row">
                        <li className="mb-3 md:mb-5 w-full lg:w-4/12">
                            <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                Legal, Repossession & Incidental charges
                            </label>
                            <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                At actuals
                            </p>
                        </li>
                        <li className="mb-3 md:mb-5 w-full lg:w-4/12">
                            <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                CIBIL Charges (only on request)
                            </label>
                            <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                <span className="WebRupee">Rs.</span>
                                <span>50</span>
                            </p>
                        </li>
                        <li className="mb-3 md:mb-5 w-full lg:w-4/12">
                            <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                Collateral Charges*
                            </label>
                            <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                <span className="WebRupee">Rs.</span>
                                <span>{lead.collateralCharges}</span> per case**
                            </p>
                        </li>
                        <li className="mb-3 md:mb-5 w-full lg:w-4/12">
                            <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                Duplicate No Due Certificate/NOC
                            </label>
                            <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                <span className="WebRupee">Rs.</span>
                                <span>500</span> per instance
                            </p>
                        </li>
                        <li className="mb-3 md:mb-5 w-full lg:w-4/12">
                            <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                Duplicate Amortisation Schedule Charges
                            </label>
                            <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                <span className="WebRupee">Rs.</span>
                                <span>200</span> per schedule
                            </p>
                        </li>
                        <li className="mb-3 md:mb-5 w-full lg:w-4/12">
                            <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                LPG/ CNG NOC / Other Special NOC
                            </label>
                            <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                <span className="WebRupee">Rs.</span>
                                <span>500</span> per instance
                            </p>
                        </li>
                        <li className="mb-3 md:mb-5 w-full lg:w-4/12">
                            <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                Commercial / Personal use NOC
                            </label>
                            <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                <span className="WebRupee">Rs.</span>
                                <span>2250</span> per NOC
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}

export default SanctionLoanReschedulement;
